import EquipmentAutoComplete from './EquipmentAutoComplete'

export { ItemComponent } from './EquipmentAutoComplete'

export default EquipmentAutoComplete
